import React, { Component } from 'react';
import Ink from 'react-ink';
import ReactGA from 'react-ga';

class AgentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sender: {
                name: '',
                nameHasError: false,
                email: '',
                emailHasError: false,
                comments: '',
                emailRegex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            },
            windowWidth: window.innerWidth
        }

        this.inputChange = this.inputChange.bind(this);
        this.contactAgentClick = this.contactAgentClick.bind(this);
        this.openContactFullscreen = this.openContactFullscreen.bind(this);
        this.onResize = this.onResize.bind(this);
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.onResize, false);
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.onResize, false);
    }

    onResize() {
        this.setState({ windowWidth: window.innerWidth });
    }

    inputChange(e) {
        this.setState({
            ...this.state,
            sender: {
                ...this.state.sender,
                nameHasError: false,
                emailHasError: false,
                [e.target.name]: e.target.value
            }
        });
    }

    contactAgentClick() {
        const { name, email, emailRegex } = this.state.sender;

        let nameHasError = false;
        let emailHasError = false;

        if (!name.trim().length) {
            nameHasError = true;
        }

        if (!email.trim().length || !emailRegex.test(email)) {
            emailHasError = true;
        }

        this.setState({
            ...this.state,
            sender: {
                ...this.state.sender,
                nameHasError,
                emailHasError
            }
        }, () => {
            if (!nameHasError && !emailHasError) {
                grecaptcha.ready(() => {
                    const sitekey = this.props.reCaptcha_key; // Google reCaptcha key from Tour data (see screenshot above)
                    grecaptcha.execute(sitekey, { action: 'homepage' }).then((token) => {
                        this.props.contactAgent(this.state.sender, this.props.agentType, token);
                        this.setState({
                            ...this.state,
                            sender: {
                                ...this.state.sender,
                                name: '',
                                email: '',
                                comments: ''
                            }
                        });
                    });
                });
            }
        });
    }

    openContactFullscreen() {
        const { agentType } = this.props;
        this.props.openContactFullscreen(`contact${agentType}`, this.agent, agentType);
    }

    phoneClick() {
        // ReactGA.event({
        //     category: 'external links',
        //     action: 'agent phone'
        // });
    }

    emailClick() {
        // ReactGA.event({
        //     category: 'external links',
        //     action: 'agent email'
        // });
    }

    websiteClick() {
        // ReactGA.event({
        //     category: 'external links',
        //     action: 'agent website'
        // });
    }

    render() {
        const { agentInfo, agentType, contactAgent } = this.props;

        if (!agentInfo.email && !agentInfo.name && !agentInfo.company) {
            return null;
        }

        const agentPhoneItem = (title, value) => {
            if (value) {
                let link = value.indexOf('+') === -1 ? `tel:+1${value}` : `tel:${value}`;
                let label = this.state.windowWidth >= 768 ? `${title}:` : `${title[0]}:`;
                return (
                    <div className="agent-contact-item">
                        <i className="fa fa-phone"></i>
                        {label}
                        <a className='agent-phone' href={link} onClick={this.phoneClick}>{value}</a>
                    </div>
                )
            } else {
                return null;
            }
        }

        const directPhoneBlock = agentPhoneItem('direct', agentInfo.phone);
        const bussinessPhoneBlock = agentPhoneItem('office', agentInfo.businessPhone);
        const cellPhoneBlock = agentPhoneItem('mobile', agentInfo.mobilePhone);
        const faxLink = agentInfo.fax.indexOf('+') === -1 ? `tel:+1${agentInfo.fax}` : `tel:${agentInfo.fax}`;
        const faxBlock = agentInfo.fax
            ? (
                <div className="agent-contact-item">
                    <i className="fa fa-fax"></i>
                    <a className='agent-fax' href={faxLink} onClick={this.phoneClick}>{agentInfo.fax}</a>
                </div>
            )
            : null;
        const emailBlock = agentInfo.email
            ? (
                <div className='agent-contact-item'>
                    <i className="fa fa-envelope"></i>
                    <span>
                        <a className="agent-mail" href={`mailto:${agentInfo.email}`} onClick={this.emailClick}>
                            {agentInfo.email}
                        </a>
                    </span>
                </div>
            )
            : null;

        const websiteBlock = agentInfo.website
            ? (
                <div className="agent-contact-item">
                    <i className="fa fa-external-link-square"></i>
                    <span>
                        <a href={`${agentInfo.orig_website}`} target='_blank' onClick={this.websiteClick}>
                            {agentInfo.website}
                        </a>
                    </span>
                </div>
            )
            : null;

        const contactFormBlock = contactAgent && agentInfo.email
            ? (
                <div className="agent-contact-form">
                    <div>
                        <input
                            type="text"
                            className={
                                this.state.sender.nameHasError
                                    ? 'agent-form-name form-control has-error'
                                    : 'agent-form-name form-control'
                            }
                            name='name'
                            value={this.state.sender.name}
                            onChange={this.inputChange}
                            placeholder='NAME' />
                        <input
                            type="text"
                            className={
                                this.state.sender.emailHasError
                                    ? 'agent-form-email form-control has-error'
                                    : 'agent-form-email form-control'
                            }
                            name='email'
                            value={this.state.sender.email}
                            onChange={this.inputChange}
                            placeholder='EMAIL' />
                        <textarea
                            className="form-control"
                            name='comments'
                            value={this.state.sender.comments}
                            onChange={this.inputChange}
                            placeholder="COMMENTS">
                        </textarea>
                        <p style={{ fontSize: 9 }}>
                            This site is protected by reCAPTCHA and the Google <a style={{ color: '#2d9cdb' }} href="https://policies.google.com/privacy">Privacy Policy</a> and
    <a style={{ color: '#2d9cdb' }} href="https://policies.google.com/terms"> Terms of Service</a> apply.
                        </p>
                        <button className="btn" onClick={this.contactAgentClick}>
                            <Ink />
                            contact agent
                        </button>
                    </div>
                </div>
            )
            : null;

        const btnContactModalBlock = contactAgent && agentInfo.email
            ? (
                <div className="btn-contact-model">
                    <button className="btn" onClick={this.openContactFullscreen}>
                        <Ink />
                        contact
                    </button>
                </div>
            )
            : null;

        const agentPhotoBlock = agentInfo.photo
            ? (
                <div className="agent-photo">
                    <img src={agentInfo.photo + '?w=260&photoTime=' + agentInfo.photoTime} alt="agent photo" />
                    {btnContactModalBlock}
                </div>
            )
            : null;

        const agentLogoBlock = agentInfo.logo
            ? (
                <div className="agent-logo">
                    <img src={agentInfo.logo + '?h=120&logoTime=' + agentInfo.logoTime} alt="agent logo" />
                </div>
            )
            : null;

        return (
            <div
                id={`contact${agentType}`}
                className="agent-component"
                ref={agent => this.agent = agent}>
                {agentLogoBlock}
                <div className="agent-component-info">
                    <div className="agent-info-block">
                        {agentPhotoBlock}
                        <div className="agent-info">
                            <h2>{agentInfo.name}</h2>
                            <div className="agent-address">
                                {(agentInfo.title || agentInfo.designations) && <p>{agentInfo.title}{((agentInfo.title && agentInfo.designations) && ", ") + agentInfo.designations}</p>}
                                {agentInfo.license_number && <p>License: {agentInfo.license_number}</p>}
                                <br />
                                <h4>{agentInfo.company}</h4>
                                <p>{agentInfo.address}</p>
                            </div>
                            <div className="agent-contact">
                                {directPhoneBlock}
                                {cellPhoneBlock}
                                {bussinessPhoneBlock}
                                {faxBlock}
                                {emailBlock}
                                {websiteBlock}
                            </div>
                        </div>
                    </div>
                    <div className="mobile-agent-info-block">
                        <div className="agent-info">
                            <div className="agent-block">
                                {agentPhotoBlock}
                                <div>
                                    <h2>{agentInfo.name}</h2>
                                    <div className="agent-address">
                                        {(agentInfo.title || agentInfo.designations) && <p>{agentInfo.title}{((agentInfo.title && agentInfo.designations) && ", ") + agentInfo.designations}</p>}
                                        {agentInfo.license_number && <p>License: {agentInfo.license_number}</p>}
                                        <br />
                                        <h4>{agentInfo.company}</h4>
                                        <p>{agentInfo.address}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="agent-contact">
                                {directPhoneBlock}
                                {bussinessPhoneBlock}
                                {cellPhoneBlock}
                                {faxBlock}
                                {emailBlock}
                                {websiteBlock}
                            </div>
                        </div>
                        {btnContactModalBlock}
                    </div>
                    {contactFormBlock}
                </div>
            </div>
        );
    }
}

export default AgentComponent;
